import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Citycabserviceinamritsar() {



  const cardData =
  {
    keyword: 'City Cab Services in Amritsar',
    heading: 'Aaryan Travels: City Cab Services in Amritsar',
    headingDescription: ' Aaryan Travels provides dependable City Cab Services in Amritsar for daily commutes, sightseeing, airport transfers, and quick city rides. Whether you’re a local resident, tourist, or business traveler, our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and comfortable travel experience across Amritsar. From visiting iconic landmarks like the Golden Temple and Jallianwala Bagh to attending meetings or events within the city, our professional chauffeurs and transparent fare system guarantee stress-free travel. Available 24/7 with doorstep pickup and flexible booking options, Aaryan Travels is your trusted partner for reliable city cab services in Amritsar.',

    top: 'Top Places to Visit in Amritsar with Aaryan Travels',

"topPlaces": [
  {
    "title": "Golden Temple (Harmandir Sahib)",
    "description": "The Golden Temple is the holiest shrine of Sikhism, renowned for its gold-plated sanctum sitting gracefully in the middle of a sacred lake. Devotees from around the world visit to seek peace and blessings. The divine sound of Gurbani kirtan and the serene reflections in the water create a heavenly atmosphere. The temple's Langar serves free meals to thousands daily, symbolizing equality and service. The Golden Temple is Amritsar’s radiant heart of devotion."
  },
  {
    "title": "Jallianwala Bagh",
    "description": "Jallianwala Bagh is a memorial park dedicated to the martyrs of the 1919 massacre led by British forces. Bullet marks on the walls and the preserved well stand as silent witnesses to the tragic event. The flame-shaped memorial and light-and-sound show evoke deep patriotism. The garden is a powerful reminder of India’s freedom struggle. Jallianwala Bagh is Amritsar’s ground of sacrifice and national pride."
  },
  {
    "title": "Wagah Border Ceremony",
    "description": "Located on the India-Pakistan border, the Wagah Border hosts the daily Beating Retreat Ceremony. Soldiers from both nations perform synchronized drills, energetic marches, and flag-lowering rituals. The roaring cheers of ‘Bharat Mata Ki Jai’ and patriotic music electrify the atmosphere. It is a thrilling spectacle of discipline and unity. Wagah Border is Amritsar’s patriotic power show."
  },
  {
    "title": "Akal Takht",
    "description": "Akal Takht, situated within the Golden Temple complex, is one of the five seats of Sikh authority established by Guru Hargobind Sahib. It stands as a symbol of justice and sovereignty. The structure reflects a fusion of strength and spirituality. Devotees visit to seek guidance and pay respects. Akal Takht is Amritsar’s seat of courage and leadership."
  },
  {
    "title": "Durgiana Temple",
    "description": "Durgiana Temple, also known as the Silver Temple, resembles the Golden Temple in architecture but is dedicated to Goddess Durga. Its holy pond and glowing facade attract both pilgrims and tourists. The intricate silver doors and peaceful ambiance make it spiritually uplifting. Festivals like Navratri are celebrated with grandeur. Durgiana Temple is Amritsar’s divine mirror of devotion."
  },
  {
    "title": "Hall Bazaar",
    "description": "Hall Bazaar is one of Amritsar’s oldest and busiest marketplaces, known for traditional Phulkari embroidery, juttis, spices, and handicrafts. The arched Mughal-style entrance welcomes shopaholics and food lovers alike. Colorful lanes filled with aroma of street snacks like Amritsari kulcha and lassi make the experience unforgettable. Hall Bazaar is Amritsar’s bustling shopping soul."
  },
  {
    "title": "Partition Museum",
    "description": "The Partition Museum documents the emotional and historical journey of India’s 1947 partition. Exhibits include letters, photographs, and personal belongings of refugees who migrated during the divide. Audio-visual stories offer moving insights into resilience and healing. It is an essential stop for understanding India’s past. The Partition Museum is Amritsar’s archive of memories and humanity."
  },
  {
    "title": "Gobindgarh Fort",
    "description": "Gobindgarh Fort is a historic fortress once ruled by Maharaja Ranjit Singh. Now converted into a cultural attraction, it features live folk performances, 7D shows, and traditional food courts. The light-and-sound show narrates Punjab’s valorous past. Visitors enjoy camel rides and weapon displays inside the fort. Gobindgarh Fort is Amritsar’s warrior heritage brought to life."
  },
  {
    "title": "Ram Bagh Gardens & Maharaja Ranjit Singh Museum",
    "description": "Ram Bagh Gardens is a peaceful green expanse once used as the summer palace of Maharaja Ranjit Singh. The museum inside displays royal artifacts, paintings, and weapons. Sculptures and fountains enhance the garden’s charm. It is ideal for leisurely walks and history tours. Ram Bagh is Amritsar’s elegant blend of nature and royalty."
  },
  {
    "title": "Khalsa College",
    "description": "Khalsa College is an architectural marvel built in Indo-Saracenic style, featuring red sandstone domes and arched corridors. Established in 1892, the institution has produced many national leaders and scholars. Its expansive campus and heritage design attract photographers and tourists. The college looks especially stunning at sunrise and sunset. Khalsa College is Amritsar’s pride in education and elegance."
  }
],


"services": [
  {
    "name": "City Cab Services in Amritsar",
    "description": "City Cab Services in Amritsar offer a convenient, reliable, and affordable way to navigate the city. Whether you're heading to work, running errands, or exploring the vibrant streets of Amritsar, our city cabs are available round-the-clock. With a fleet of well-maintained vehicles and courteous drivers familiar with local routes, we ensure timely pickups, smooth rides, and a stress-free travel experience. Our cabs are equipped with modern amenities, real-time tracking, and flexible booking options—perfect for both locals and tourists alike."
  },
  {
    "name": "Amritsar Urban Taxi",
    "description": "Amritsar Urban Taxi service is designed to make inner-city travel fast and comfortable. Operating across all major localities and neighborhoods, our taxis are driven by professionals who prioritize safety and punctuality. Whether you’re commuting to your office, attending meetings, or heading to a shopping district, this service ensures you reach your destination without delays. Affordable fares, 24/7 availability, and a user-friendly booking experience make it a preferred choice for daily travel."
  },
  {
    "name": "Local Taxi Amritsar",
    "description": "Our Local Taxi service in Amritsar provides efficient and cost-effective transportation within the city. Ideal for short trips, grocery runs, school pickups, and visiting friends or family, the service combines quick availability with friendly service. All taxis are clean, sanitized, and equipped for a safe and pleasant ride. With minimal wait times and consistent pricing, this is your go-to solution for local commutes in Amritsar."
  },
  {
    "name": "In-City Cab Amritsar",
    "description": "In-City Cab Amritsar is your trusted travel companion for city rides. Whether it’s a short hop to the market or a longer trip across town, our in-city cabs provide smooth, timely, and affordable transport. Our drivers are experienced with navigating Amritsar’s traffic, and we offer a range of vehicles—from hatchbacks to premium sedans—to suit your needs. Book on-demand or in advance, and enjoy transparent pricing and excellent service every time."
  },
  {
    "name": "Amritsar City Rides",
    "description": "Enjoy comfortable and efficient travel with Amritsar City Rides—your reliable partner for daily commuting. With real-time cab tracking, professional drivers, and 24x7 service, our city rides ensure you're never late. Whether you're heading to school, work, or leisure activities, our diverse fleet and affordable pricing make city travel seamless and convenient. Experience hassle-free urban mobility like never before."
  },
  {
    "name": "24x7 City Taxi Amritsar",
    "description": "Travel anytime with 24x7 City Taxi Amritsar. This round-the-clock service is ideal for early morning commutes, late-night returns, and any urgent travel within the city. With a well-spread network of cabs and verified drivers, we ensure fast response times and secure travel. Booking is easy and available online or by phone, giving you full control over your journey regardless of the hour."
  },
  {
    "name": "Amritsar City Cab Booking",
    "description": "Amritsar City Cab Booking offers an easy and fast way to schedule your urban rides. Through our digital platform or call support, you can book cabs instantly, choose from multiple vehicle types, and get real-time fare estimates. Whether you’re booking for yourself or arranging travel for guests, our system ensures smooth scheduling, timely pickups, and consistent service throughout Amritsar."
  },
  {
    "name": "Local Cab Hire Amritsar",
    "description": "Hire local cabs in Amritsar for city tours, market runs, or daily work travel. With Local Cab Hire Amritsar, you get affordable rates, on-time pickups, and courteous drivers who know the city inside out. It’s a perfect option for short-term rides, hourly rentals, or flexible travel plans that need a dependable transportation partner within city limits."
  },
  {
    "name": "Affordable City Taxi Amritsar",
    "description": "Get around the city without breaking the bank with our Affordable City Taxi service in Amritsar. This service focuses on budget-friendly rides while maintaining comfort, cleanliness, and timely service. Whether it's a routine commute or a last-minute ride, we offer the most competitive rates in the city along with excellent service and 24/7 support."
  },
  {
    "name": "City Sedan Cab Amritsar",
    "description": "Enjoy smooth, quiet, and comfortable rides with our City Sedan Cab service in Amritsar. Ideal for professionals, small families, or solo travelers, these sedans come equipped with AC, clean interiors, and experienced drivers. Suitable for daily commutes or business meetings, our sedan cabs provide a classy yet economical way to travel around the city."
  },
  {
    "name": "Amritsar City SUV Rental",
    "description": "For group travel or extra luggage needs, Amritsar City SUV Rental offers spacious vehicles for comfortable city journeys. Whether you're heading to events, airports, or long meetings across town, our SUVs combine luxury and utility. You get ample space, a smooth ride, and a professional driver for all your urban travel requirements."
  },
  {
    "name": "Best City Cab Amritsar",
    "description": "Ranked among the best in the region, our City Cab service in Amritsar is known for its reliability, quality vehicles, and exceptional customer care. We prioritize punctuality, safety, and transparency in every ride. With a wide fleet and customizable packages, we cater to all travel types—from daily errands to special events in the city."
  },
  {
    "name": "Fast Cab Service Amritsar",
    "description": "Need a cab quickly? Our Fast Cab Service in Amritsar ensures minimal wait times with a strong fleet presence throughout the city. Ideal for urgent travel, spontaneous plans, or time-sensitive errands, we provide instant booking, live tracking, and prompt support. Trust us to get you moving fast and safely every time."
  },
  {
    "name": "Amritsar City Transport",
    "description": "Amritsar City Transport services are built to make your urban commute smooth, efficient, and cost-effective. We offer a wide selection of vehicles, professional drivers, and flexible booking options to meet your daily transportation needs. Whether you're a resident or visitor, our city transport service ensures you're always connected to your next destination."
  },
  {
    "name": "City Ride Amritsar",
    "description": "City Ride Amritsar is your all-in-one solution for city-based travel, offering clean vehicles, courteous drivers, and real-time booking features. From short trips to regular commutes, we make every ride pleasant, punctual, and affordable. Experience convenience and comfort with every ride inside Amritsar's busy streets."
  }
],
"tableData": [
  ["City Cab Services in Amritsar", "Amritsar Urban Taxi"],
  ["Local Taxi Amritsar", "In-City Cab Amritsar"],
  ["Amritsar City Rides", "24x7 City Taxi Amritsar"],
  ["Amritsar City Cab Booking", "Local Cab Hire Amritsar"],
  ["Affordable City Taxi Amritsar", "City Sedan Cab Amritsar"],
  ["Amritsar City SUV Rental", "Best City Cab Amritsar"],
  ["Fast Cab Service Amritsar", "Amritsar City Transport"],
  ["City Ride Amritsar", "—"]
] ,


"whychoose": [
  {
    "WhyChooseheading": "Reliable City Cab Services in Amritsar",
    "WhyChoosedescription": "Aaryan Travels offers trusted and professional city cab services across Amritsar for everyday local travel."
  },
  {
    "WhyChooseheading": "Quick and Convenient Pickups Anywhere in the City",
    "WhyChoosedescription": "Our drivers ensure prompt pickup and drop services across all areas of Amritsar."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Cabs for Local Commutes",
    "WhyChoosedescription": "All our vehicles are sanitized, air-conditioned, and well-maintained for your comfort and safety."
  },
  {
    "WhyChooseheading": "Drivers with Local Expertise",
    "WhyChoosedescription": "Our experienced drivers are familiar with Amritsar's traffic patterns and shortcuts for smooth city rides."
  },
  {
    "WhyChooseheading": "Affordable City Travel with Transparent Pricing",
    "WhyChoosedescription": "Get upfront fares without hidden charges – including fuel, driver, and toll costs."
  },
  {
    "WhyChooseheading": "24/7 Availability for Anytime Travel",
    "WhyChoosedescription": "Book your city cab anytime—day or night—with our round-the-clock service and support."
  },
  {
    "WhyChooseheading": "Flexible Ride Options for Daily Travel",
    "WhyChoosedescription": "Whether it's a short trip, hourly rental, or day-long booking, we have options that suit your needs."
  },
  {
    "WhyChooseheading": "Variety of Cabs for Solo or Group City Rides",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, or SUVs based on your group size and travel comfort."
  }
]






























  }

const faqData = [
  {
    question: 'Does Aaryan Travels provide city cab services in Amritsar?',
    answer: 'Yes, Aaryan Travels offers reliable and comfortable city cab services throughout Amritsar for local travel and daily commuting.',
  },
  {
    question: 'How do I book city cabs in Amritsar with Aaryan Travels?',
    answer: 'You can book your city cab easily through our website, mobile app, or by calling our 24x7 customer support helpline.',
  },
  {
    question: 'What types of vehicles are available for city cab services in Amritsar?',
    answer: 'Our city cab fleet includes hatchbacks, sedans, SUVs, and premium cars suited for individual, family, or business travel needs.',
  },
  {
    question: 'Are Aaryan Travels’ city cab services suitable for daily commuting in Amritsar?',
    answer: 'Yes, our city cab services are ideal for daily office commutes, shopping trips, city tours, and errands in Amritsar.',
  },
  {
    question: 'Are your drivers experienced and knowledgeable about city routes in Amritsar?',
    answer: 'Absolutely. Our drivers are well-trained, courteous, and familiar with all major areas and traffic patterns in Amritsar.',
  },
  {
    question: 'Is hourly cab service available within the city limits of Amritsar?',
    answer: 'Yes, Aaryan Travels offers hourly rental packages for flexible and affordable intra-city travel in Amritsar.',
  },
  {
    question: 'Are the city cabs from Aaryan Travels sanitized and safe?',
    answer: 'Yes, we follow strict hygiene protocols, including regular vehicle sanitization and safety checks, for all our city cabs.',
  },
  {
    question: 'Can I avail Aaryan Travels’ city cab service in Amritsar 24x7?',
    answer: 'Yes, we operate 24x7 to provide hassle-free travel anytime you need a cab within Amritsar.',
  },
  {
    question: 'What payment options are accepted for city cab rides in Amritsar?',
    answer: 'We accept cash, cards, UPI, and digital wallets to ensure smooth and secure transactions.',
  },
  {
    question: 'Can I schedule or pre-book a city cab in Amritsar?',
    answer: 'Yes, you can pre-book city cabs with Aaryan Travels for timely pickups according to your schedule.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Balwinder Singh',
    feedback: 'Aaryan Travels’ city cab service in Amritsar is top-notch. The booking was easy, and the ride was smooth and comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Amandeep Kaur',
    feedback: 'Very professional and prompt city cab service in Amritsar. Aaryan Travels is my go-to for local travel.',
    rating: 5,
  },
];




























































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "City Cab Services in Amritsar",
  "image": "https://aaryantravels.com/assets/images/city-cab-amritsar.jpg", // replace with actual image URL
  "description": "Reliable and affordable city cab services in Amritsar by Aaryan Travels. Available 24x7 for local rides, sedan and SUV rentals, perfect for urban travel within Amritsar.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.5",  // example rating, update if needed
    "ratingCount": "1200", // example rating count, update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "800",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/city-cab-services-amritsar"
  }
};





  return (
    <div>

<Helmet>
  <title>City Cab Services in Amritsar | Local & Affordable Taxi | Aaryan Travels</title>
  <meta
    name="description"
    content="Reliable and affordable city cab services in Amritsar by Aaryan Travels. Available 24x7 for local rides, sedan and SUV rentals, perfect for urban travel within Amritsar."
  />
  <meta
    name="keywords"
    content="City Cab Services in Amritsar, Amritsar Urban Taxi, Local Taxi Amritsar, In-City Cab Amritsar, Amritsar City Rides, 24x7 City Taxi Amritsar, Amritsar City Cab Booking, Local Cab Hire Amritsar, Affordable City Taxi Amritsar, City Sedan Cab Amritsar, Amritsar City SUV Rental, Best City Cab Amritsar, Fast Cab Service Amritsar, Amritsar City Transport, City Ride Amritsar"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/29.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Citycabserviceinamritsar;